import React, { Component } from 'react';
import classnames from 'classnames';
import Nav from '../../components/nav/Nav';
import ProjectTags from '../../components/project-tags/ProjectTags';
import ProjectRows from '../../components/project-rows/ProjectRows';
import ProjectFullRows from '../../components/project-full-rows/ProjectFullRows';
import Footer from '../../components/footer/Footer';
import Loading from '../../components/loading-v2/LoadingV2';
import styles from './Projects.css';
import buildProjects from '../../utils/projects';
import langIsEn from '../../utils/langIsEn';
import BaseMeta from '../../components/base-meta/BaseMeta';
import ProjectsData from '../../constants/projects.json';
import TagsData from '../../constants/tags.json';

class Projects extends Component {
  constructor(props) {
    super(props);

    this.onLangChange = this.onLangChange.bind(this);

    const projects = buildProjects(ProjectsData.records);
    const tags = TagsData.records.map((record) => {
      return {
        engName: record.fields.engName,
        chtName: record.fields.chtName,
      };
    });
    this.state = {
      projects: projects,
      tags: tags,
      langIsEn: langIsEn(),
      tagsHeight: 0,
      loadingAnimDone: false,
    };
  }

  onLangChange() {
    this.setState({ langIsEn: langIsEn() });
  }

  onHeightCalculated(tagsHeight) {
    this.setState({ tagsHeight });
  }

  getProjects(tag) {
    const { projects } = this.state;

    if (tag === 'All Projects') {
      return projects;
    }

    if (tag) {
      return projects.filter(project =>
        project.tags.indexOf(tag) !== -1
      );
    }

    return projects;
  }

  renderProjectRows() {
    const { tag } = this.props.params;
    const { projects } = this.state;
    const filteredProjects = this.getProjects(tag);
    const requireSort = filteredProjects.length !== projects.length;

    if (tag === '‘Reinvent’ Projects') {
      return <ProjectFullRows projects={filteredProjects} picUrlAttr="businessDesignPicURL" key="businessDesign" />;
    }

    if (tag === 'Identity') {
      return <ProjectFullRows projects={filteredProjects} picUrlAttr="logoPicURL" key="logo" />;
    }

    return (
      <ProjectRows
        projects={filteredProjects}
        key={this.getProjects(tag)}
        requireSort={requireSort}
      />
    );
  }

  render() {
    const { tags, loadingAnimDone } = this.state;
    const { tag } = this.props.params;
    const tagName = tag ? tag : 'All Projects';

    if (!this.state.loadingAnimDone) {
      setTimeout(() => this.setState({ loadingAnimDone: true }), 1000);
      return (
        <BaseMeta
          path={this.props.location.pathname}
          title="Projects"
        >
          <Loading hide />
        </BaseMeta>
      );
    }

    return (
      <main>
        <BaseMeta
          path={this.props.location.pathname}
          title="Projects"
        />
        <Nav activeItem="projects" onLangChange={this.onLangChange} />
        <div className={classnames({ 'animated fadeIn': loadingAnimDone })}>
          <div className={styles.projectTags}>
            <ProjectTags
              tags={tags}
              activeTag={tagName}
              onHeightCalculated={this.onHeightCalculated.bind(this)}
              langIsEn={this.state.langIsEn}
            />
          </div>
          <div
            className={styles.projectContainer}
            style={{
              top: `${this.state.tagsHeight}px`,
              opacity: this.state.tagsHeight === 0 ? 0 : 1,
            }}
          >
            <section className="container">
              <p className={styles.filterName}>{tagName}</p>
              {this.renderProjectRows()}
            </section>
            <Footer />
          </div>
        </div>
      </main>
    );
  }
}

export default Projects;



// WEBPACK FOOTER //
// ./src/containers/projects/Projects.js